import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import { auth } from '../../config/firebase';
import './styles.css';

export const EmailVerification = () => {
  const [error, setError] = useState('');
  const [verifying, setVerifying] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      if (isSignInWithEmailLink(auth, window.location.href)) {
        let email = window.localStorage.getItem('emailForSignIn');
        
        if (!email) {
          // If email is not found in localStorage, prompt user
          email = window.prompt('Please provide your email for confirmation');
        }

        try {
          await signInWithEmailLink(auth, email, window.location.href);
          window.localStorage.removeItem('emailForSignIn'); // Clean up
          navigate('/setlist'); // Redirect to setlist after successful verification
        } catch (err) {
          setError('Error verifying email: ' + err.message);
        }
      }
      setVerifying(false);
    };

    verifyEmail();
  }, [navigate]);

  if (verifying) {
    return (
      <div className="verification-container">
        <div className="verification-content">
          <h2>Verifying your email...</h2>
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="verification-container">
        <div className="verification-content error">
          <h2>Verification Error</h2>
          <p>{error}</p>
          <button onClick={() => navigate('/')}>Return to Sign Up</button>
        </div>
      </div>
    );
  }

  return null;
};
